export default __webpack_public_path__ + "static/media/ic_minus.586ef8c1.svg";